import React from "react";
import { Typography } from "../../Components/Typography";
import Button from "../../Components/Button";
import { privacyPolicyContent } from "./constants";

const PrivacyPolicyModal = ({ open, onClose, onAgree }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-2xl rounded-2xl bg-white shadow-2xl border border-slate-200 overflow-hidden">
        <div className="p-6">
          <Typography as="h3" className="text-lg font-bold text-primary-900 text-left">
            Privacy Policy
          </Typography>
          <div className="mt-4 max-h-[60vh] overflow-y-auto rounded-lg border border-slate-200 bg-slate-50 p-4 text-left">
            <pre className="whitespace-pre-wrap text-sm text-slate-800 font-sans leading-relaxed m-0">
              {privacyPolicyContent}
            </pre>
          </div>
        </div>
        <div className="flex items-center justify-end gap-3 px-6 py-4 bg-slate-50 border-t border-slate-200">
          <Button type="button" variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button type="button" onClick={onAgree}>
            I Agree
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
